import { createContext } from 'react';
import type { CarouselItemState } from './types';

export const CarouselItemStateContext = createContext<
  CarouselItemState | undefined
>(undefined);
